import firebase from 'firebase/app'
import firebaseConfig from './config'
import 'firebase/firestore'

export function initFirebase() {
  firebase.initializeApp(firebaseConfig)
  firebase.firestore()
}
